import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class IdleTimeoutService {
  private timeoutId: any;
  private readonly TIMEOUT_DURATION = 60 * 60 * 1000; // 20 minutes
  private dialogTimeoutId: any;
  private readonly DIALOG_DURATION = 20 * 1000; // 10 seconds
  private countdown = this.DIALOG_DURATION / 1000;
  private countdownInterval: any;

  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    private authService: AuthService
  ) {}

  private activityListener = this.resetTimer.bind(this);

  startWatching(): void {
    console.log('Activity being watched!');
    this.resetTimer();
    window.addEventListener('mousemove', this.activityListener);
    window.addEventListener('keypress', this.activityListener);
    window.addEventListener('click', this.activityListener);
    window.addEventListener('scroll', this.activityListener);
    //window.addEventListener('beforeunload', this.handleWindowClose.bind(this));
  }

  private handleWindowClose(event: Event) {
    this.authService.logout(); // Log out the user when the page is closed
  }

  private resetTimer(): void {
    clearTimeout(this.timeoutId);
    clearTimeout(this.dialogTimeoutId);
    this.timeoutId = setTimeout(
      () => this.showLogoutWarning(),
      this.TIMEOUT_DURATION
    );
  }

  stopWatching(): void {
    console.log('Stopping idle timeout watch');
    clearTimeout(this.timeoutId);
    clearTimeout(this.dialogTimeoutId);
    clearInterval(this.countdownInterval);
    window.removeEventListener('mousemove', this.activityListener);
    window.removeEventListener('keypress', this.activityListener);
    window.removeEventListener('click', this.activityListener);
    window.removeEventListener('scroll', this.activityListener);
    window.removeEventListener(
      'beforeunload',
      this.handleWindowClose.bind(this)
    );
  }

  private showLogoutWarning(): void {
    this.countdown = this.DIALOG_DURATION / 1000; // Reset countdown timer
    this.updateDialogMessage();

    // Start countdown
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      this.updateDialogMessage();

      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.confirmationService.close();
        this.logout();
      }
    }, 1000);

    // Show PrimeNG confirm dialog
    this.confirmationService.confirm({
      message: this.getDialogMessage(),
      header: 'Session Timeout Warning',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        clearInterval(this.countdownInterval); // Stop countdown if user clicks "Stay Logged In"
        this.resetTimer();
      },
      reject: () => this.logout(),
    });
  }

  private getDialogMessage(): string {
    return `You will be logged out due to inactivity in <strong>${this.countdown} seconds</strong>. Do you want to stay logged in?`;
  }

  private updateDialogMessage(): void {
    this.confirmationService.confirm({
      message: this.getDialogMessage(),
      header: 'Session Timeout Warning',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        clearInterval(this.countdownInterval);
        this.resetTimer();
      },
      reject: () => this.logout(),
    });
  }

  private logout(): void {
    this.stopWatching();
    this.authService.logout();
    console.log('Logged out due to inactivity');
    this.router.navigate(['/auth']);
  }
}
